import React from 'react'

const TitleComponent = (props) => {
    return (
        <div className={`${props.className || ''} section_title`}>
            <span className="section_title--desktop">
                {props.children}
            </span>
        </div>
    )
}

export default TitleComponent
